export const qaEnvConfig = {
  DISABLED_CONSOLE_MSG: false,
  YOLO_BASE_URL: 'https://qa.yolorekt.finance',
  BASE_BRANCH: 'QA',

  // CRYPTO
  APPROVED_CHAINS_IDS: [137],

  //BACKEND CONNECTION
  YOLO_API_BASE_URL: 'https://qa.api.yolorekt.finance',
  BACKEND_SOCKET_URL: 'https://prod.yolorekt.finance',
  CONTRACTS_VERSION: '33',
}
